/**
 * NavBarLogo Component
 *
 * Shared logo component that renders the VoiceRecipe pure HTML/CSS logo
 * (waveform icon + wordmark), wrapped in a Link to "/".
 * Used by MainLayout (AppBar), LandingPage, LoginPage, and ReusableFooter.
 *
 * Requirements: 2.1, 2.2, 2.3, 2.4
 */

import { Link } from 'react-router-dom';
import { VoiceRecipeLogo } from './VoiceRecipeLogo';

export interface NavBarLogoProps {
    size?: 'small' | 'medium'; // small for AppBar, medium for LoginPage
}

export function NavBarLogo({ size = 'small' }: NavBarLogoProps) {
    return (
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <VoiceRecipeLogo size={size} />
        </Link>
    );
}
